var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Portal',{attrs:{"to":"side-menu"}},[_c('div',{staticClass:"sticky overflow-hidden relative lg:mr-0",style:({
      top: `${_vm.navHeight}px`,
      height: `calc(100vh - ${_vm.navHeight}px`,
      transition: 'all 0.5s ease',
      width: _vm.isOpen ? '200px' : 0,
      marginRight: _vm.isOpen ? '-200px' : 0,
    })},[_c('div',{staticClass:"absolute top-0 bottom-0 right-0 px-4 py-3 bg-gray-900 border-0 border-t-2 border-solid border-gray-1000",staticStyle:{"width":"200px"}},[_vm._t("default"),(_vm.isNotDefaultDomain)?_c('div',{staticClass:"fixed bottom-0"},[_c('img',{staticClass:"sr-powered-by my-3",attrs:{"src":"https://cdn.sportsrecruits.com/logos/powered-by-SportsRecruits.svg"}})]):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }